import { FC } from "react";
import { Box, styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { H1, H2, Paragraph } from "../../components/Typography";
import { GullButton } from "../../components/buttons/GullButton";

const NotFoundContainer = styled(Box)(() => ({
  height: "100vh",
  padding: "100px 0",
  textAlign: "center",
  backgroundImage: "url(/assets/images/page-bg-bottom.png)",
  backgroundPositionY: "bottom",
  backgroundSize: "100%",
  backgroundRepeat: "no-repeat",
}));

const NotFound: FC = () => {
  const navigate = useNavigate();

  return (
    <NotFoundContainer>
      <H1 sx={{ fontSize: 70, fontWeight: "bold" }}>404</H1>
      <H2 sx={{ fontSize: 40, fontWeight: "bold" }}>Error!</H2>
      <Paragraph sx={{ mt: "15px", mb: "35px", fontSize: 20 }}>
        Sorry! The page you were looking for doesn't exist.
      </Paragraph>
      <GullButton
        rounded={true}
        variant="contained"
        color="primary"
        onClick={() => navigate(-1)}
        sx={{ fontSize: 20, px: "2rem" }}
      >
        Go Back
      </GullButton>
    </NotFoundContainer>
  );
};

export default NotFound;
